document.addEventListener('DOMContentLoaded', function() {
    initializeCarousels();

    function initializeCarousels() {
        const carousels = document.querySelectorAll('.manitoba-articles-carousel .swiper');
        
        carousels.forEach(function(carousel) {
            const slides = carousel.querySelectorAll('.swiper-slide');
            
            if (slides.length < 2) {
                return; 
            }
            
            
            const autoplayEnabled = carousel.parentElement.dataset.autoplay === 'true';
            const autoplayDelay = carousel.parentElement.dataset.autoplayDelay || 5000;

            const swiperConfig = {
                slidesPerView: 1,
                spaceBetween: 10
            };

            if (autoplayEnabled) {
                swiperConfig.autoplay = {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                };
            }

            const paginationEl = carousel.querySelector('.swiper-pagination');
            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }

            // Récupérer l'ID du conteneur parent
            const carouselContainer = carousel.closest('.manitoba-articles-carousel');
            const carouselId = carouselContainer ? carouselContainer.id : null;
            
            // Sélectionner les boutons de navigation avec l'ID du conteneur
            const nextEl = carouselId ? document.querySelector(`[data-nav-next="${carouselId}"]`) : null;
            const prevEl = carouselId ? document.querySelector(`[data-nav-prev="${carouselId}"]`) : null;
            
            if (nextEl && prevEl) {
                swiperConfig.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                };
            } else {
                // Fallback sur les boutons de navigation internes si les boutons externes ne sont pas trouvés
                const nextButton = carousel.querySelector('.swiper-button-next');
                const prevButton = carousel.querySelector('.swiper-button-prev');
                
                if (nextButton && prevButton) {
                    swiperConfig.navigation = {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    };
                }
            }

            new Swiper(carousel, swiperConfig);
        });
    }
}); 